import React from 'react';

const MUTUELLES = [
  'Almerys', 'Itelis', 'Santéclair', 'Carte Blanche', 'Kalixia', 'Sévéane',
  'Viamédis', 'Actil', 'Kalivia', 'Tp Léa', 'Korelio', 'Istya', 'Cetim', 'Sp Santé',
];

export const MutuellesMarquee = ({ accent = '#FF004D', bg = '#0e0f12' }) => {
  const loop = [...MUTUELLES, ...MUTUELLES];
  return (
    <div className="border-b border-white/10 overflow-hidden" data-testid="mutuelles-band">
      <div className="max-w-[1320px] mx-auto px-5 pt-6 pb-3.5">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: accent }} />
          <span style={{ color: accent }} className="text-[12px] font-bold uppercase tracking-wider">Tiers payant — Mutuelles acceptées</span>
        </div>
      </div>
      <div className="relative mut-wrap">
        <div className="flex gap-3 w-max mut-track px-4">
          {loop.map((m, i) => (
            <span key={i} className="shrink-0 px-5 py-3 rounded-xl bg-white/5 border border-white/10 text-white/85 text-[14px] font-semibold whitespace-nowrap flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent }} />
              {m}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 md:w-40 z-10" style={{ background: `linear-gradient(to right, ${bg} 0%, ${bg}f0 35%, ${bg}00 100%)` }} />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 md:w-40 z-10" style={{ background: `linear-gradient(to left, ${bg} 0%, ${bg}f0 35%, ${bg}00 100%)` }} />
      </div>
      <div className="max-w-[1320px] mx-auto px-5 pt-3 pb-6">
        <p className="text-white/35 text-[11.5px]">Et bien d&apos;autres — n&apos;hésitez pas à nous demander si votre mutuelle est partenaire.</p>
      </div>
      <style>{`
        @keyframes mutScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .mut-track { animation: mutScroll 45s linear infinite; }
        .mut-wrap:hover .mut-track { animation-play-state: paused; }
      `}</style>
    </div>
  );
};

export default MutuellesMarquee;
